import { useAuthStore } from "@/modules/auth/stores/authStore";
import { storeToRefs } from "pinia";

// Interceptor de rutas
export const authGuard = (to, from, next) => {
    const auth = useAuthStore();
    const { isAuthenticated } = storeToRefs(auth);

  

    // Rutas que requieren autenticación
    if (to.meta.requiresAuth && !isAuthenticated.value) {
        return next({ path: "/signin" });
    }

    // Rutas de invitados (login, registro)
    if (to.meta.requiresGuest && isAuthenticated.value) {
        return next({ path: "/dashboard-default" });
    }
    return next();
};
